import AWS from 'aws-sdk';
import axios from 'axios';

async function refreshIdToken() {
  const refreshToken = localStorage.getItem("refreshToken");
  const clientId = process.env.REACT_APP_COGNITO_CLIENTID;

  if (!refreshToken) {
    console.error("❌ No refresh token found.");
    return null;
  }

  const url = `https://cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/`;

  const payload = {
    AuthFlow: "REFRESH_TOKEN_AUTH",
    ClientId: clientId,
    AuthParameters: {
      REFRESH_TOKEN: refreshToken,
    },
  };

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "X-Amz-Target": "AWSCognitoIdentityProviderService.InitiateAuth",
      "Content-Type": "application/x-amz-json-1.1",
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json();

  if (data.AuthenticationResult?.IdToken) {
    const newIdToken = data.AuthenticationResult.IdToken;
    localStorage.setItem("idToken", newIdToken);
    return newIdToken;
  }

  return null;
}

const preserveLocalStorageKeys = (keysToKeep) => {
  const preserved = {};

  keysToKeep.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value !== null) {
      preserved[key] = value;
    }
  });

  localStorage.clear();

  Object.entries(preserved).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
};
function handleSessionExpired() {

  const keep = ["rememberMe", "rememberedEmail", "rememberedPassword"];
  const saved = {};
  keep.forEach(k => {
    if (localStorage.getItem(k)) saved[k] = localStorage.getItem(k);
  });

  localStorage.clear();
  Object.entries(saved).forEach(([k, v]) =>
    localStorage.setItem(k, v)
  );

  localStorage.setItem(
    "SESSION_EXPIRED_MESSAGE",
    "Your session has expired. Please log in again."
  );

  window.location.replace("/");
}


class Api {

  constructor(successCallBack, failureCallBack) {
    this.successCallBack = successCallBack;
    this.failureCallBack = failureCallBack;
  }



  // POST API method with IAM
  // postAPI = (requestData, path) => {
  //   try {
  //     const endpoint = process.env.REACT_APP_AWS_ENDPOINT;
  //     const region = process.env.REACT_APP_AWS_REGION;

  //     // Validate environment variables
  //     if (!endpoint || !region) {
  //       throw new Error("AWS endpoint or region is not defined");
  //     }

  //     // Create a new AWS HttpRequest
  //     const request = new AWS.HttpRequest(endpoint, region);
  //     request.method = 'POST';
  //     request.path = path;
  //     request.headers = {
  //       host: request.endpoint.host,
  //     };
  //     request.body = JSON.stringify(requestData);

  //     // Using the default AWS credentials provider chain for credentials
  //     const credentials = AWS.config.credentials || new AWS.Credentials({
  //       accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,   
  //       secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY, 
  //     });

  //     // Sign the request with AWS Signature Version 4
  //     const signer = new AWS.Signers.V4(request, 'execute-api');
  //     signer.addAuthorization(credentials, new Date());
  //     const headers = request.headers;
  //     delete headers.host;  // Remove the host header as it's already included in the AWS signature

  //     // Make the API call using Axios with the signed headers
  //     return axios({
  //       url: endpoint + request.path,
  //       headers: { ...headers, 'Content-Type': 'application/json' },
  //       data: JSON.stringify(requestData),
  //       method: 'POST',
  //     })
  //     .then((response) => {
  //       console.log('API response:', response);
  //       if (this.successCallBack) this.successCallBack(response); 
  //       return response;  
  //     })
  //     .catch((error) => {
  //       console.error('Error in POST API:', error);
  //       if (this.failureCallBack) this.failureCallBack(error); 
  //       throw error;  
  //     });
  //   } catch (error) {
  //     console.error('Error in POST API request:', error);
  //     if (this.failureCallBack) this.failureCallBack(error); 
  //     throw error;  
  //   }
  // }

  postAPI = async (body, path) => {
    const baseUrl = process.env.REACT_APP_AWS_ENDPOINT;
    const endpoint = `${baseUrl}${path}`;

    let idToken = localStorage.getItem("idToken");

    const makeRequest = async (token, retry = true) => {
      try {
        const response = await fetch(endpoint, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        });


        if (response.status === 401) {
          throw new Error("401 Unauthorized");
        }

        return response; // success
      } catch (err) {
        console.error("Network / fetch error or 401:", err);

        // Retry only once
        if (retry && (err instanceof TypeError || err.message.includes("401"))) {
          console.log("🔄 Refreshing ID token due to fetch/401 error...");

          const newToken = await refreshIdToken();

          if (!newToken) {
            console.log("❌ Failed to refresh token, logging out...");
            handleSessionExpired();
            return new Promise(() => { });
          }

          // Retry request with new token, but do not retry again
          return makeRequest(newToken, false);
        }

        // If already retried or error not retryable → throw
        throw err;
      }
    };

    // ---- FIRST REQUEST ----
    let response = await makeRequest(idToken);

  
    // ---- STILL FAILED ----
    if (!response.ok) {
      const err = await response.text();       // FIXED
      throw new Error(`HTTP ${response.status}: ${err}`);
    }

    console.log("Response : ", response);

    let text = await response.text();

    let jsonResponse;
    try {
      jsonResponse = JSON.parse(text);
    } catch {
      jsonResponse = text; // fallback (string, empty body, etc.)
    }

    return { data: jsonResponse };


  }


  // GET API method
  getAPI = async (endPoint) => {
    try {
      AWS.config.update({
        region: process.env.REACT_APP_AWS_REGION,
        accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
        secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
      });

      // Create an Axios instance with AWS Signature Version 4 interceptor
      const axiosWithAuth = axios.create();
      axiosWithAuth.interceptors.request.use(async (config) => {
        const endpoint = endPoint;
        const region = process.env.REACT_APP_AWS_REGION;

        // Create an AWS HttpRequest object
        const request = new AWS.HttpRequest(endpoint, region);
        request.method = 'GET';
        request.headers = {
          host: request.endpoint.host,
        };

        // Sign the request using AWS Signature Version 4
        const signer = new AWS.Signers.V4(request, 'execute-api');
        signer.addAuthorization(AWS.config.credentials, new Date());
        const headers = request.headers;
        delete headers.host;

        // Set AWS headers in the Axios request
        config.headers = {
          ...config.headers,
          ...headers,
        };

        return config;
      });

      // Fetch data using Axios with AWS headers
      const response = await axiosWithAuth.get(endPoint);
      if (this.successCallBack) this.successCallBack(response);
      return response;
    } catch (error) {
      console.error('Error in GET API:', error);
      if (this.failureCallBack) this.failureCallBack(error);
      return error;
    }
  }
}

export default Api;